import webuiState from "../app/InternalStateService";
import { triggerSet } from "./Component";
import CommonUtils from "@tinqin/tinqin-utils/src/common";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

export const SET_MODAL = "SET_MODAL";
export const CLEAR_MODAL = "CLEAR_MODAL";

//ACTION CREATORS:
export function setGlobalModalState(target) {
    return {
        type: SET_MODAL,
        payload: {
            modal: target
        }
    };
}

export function clearGlobalModalState() {
    return {
        type: CLEAR_MODAL
    };
}

//SIREN ACTIONS:
export function openModalFromSirenAction(action, widgetId, computedBindTo) {
    const setUiState = webuiState.getActionByName("component.setUiState");
    const clearUiState = webuiState.getActionByName("component.clearUiState");
    return (dispatch, getState) => {
        var openModal = getState().getIn(["global", "modal"]);
        var openModalFullPath, openModalPath, openModalWidget, modalPath;
        if (action.targets && action.targets[0]) {
            modalPath = widgetId + "." + action.targets[0];
            if (openModal) {
                openModalFullPath = openModal.split(".");
                openModalWidget = openModalFullPath.shift();
                openModalPath = openModalFullPath.join(".");
                dispatch(clearUiState(openModalWidget, openModalPath));
            }
            dispatch(setUiState(widgetId, action.targets[0], { visible: true }));
            dispatch(setGlobalModalState(modalPath));
        } else {
            WEBUILogs.warn("Missing targets for action openModal");
        }
    };
}
export function closeModalFromSirenAction(action, widgetId, computedBindTo) {
    const setUiState = webuiState.getActionByName("component.setUiState");
    const clearUiState = webuiState.getActionByName("component.clearUiState");
    return (dispatch, getState) => {
        var openModal = getState().getIn(["global", "modal"]);
        var openModalFullPath, openModalWidget, openModalPath;
        if (openModal) {
            openModalFullPath = openModal.split(".");
            openModalWidget = openModalFullPath.shift();
            openModalPath = openModalFullPath.join(".");
            dispatch(clearUiState(openModalWidget, openModalPath));
            dispatch(setUiState(widgetId, openModalPath, { visible: false }));
            dispatch(clearGlobalModalState());
        }
    };
}

export function compareCachedModalData(cachedDataPath, data) {
    return (dispatch, getState) => {
        var fullCachedDataPath = cachedDataPath.slice();
        fullCachedDataPath.unshift("data");
        var cachedData = getState().getIn(fullCachedDataPath);
        if (cachedData) {
            cachedData = cachedData.toJSON();
        }
        if (!CommonUtils.isEqual(cachedData, data)) {
            dispatch(triggerSet(cachedDataPath, data));
        }
    };
}
